module.exports = __webpack_public_path__ + "img/TurningStool_Hero.d21d8e23.jpg";